__turbopack_context__.v({
  "root": "amount-module-scss-module__NHRVOW__root",
});
